import { css } from '@emotion/css';
import React from 'react';
import { User } from '../../models/User';
import { UserListItem } from './UserListItem';

interface UserListProps {
  users: User[];
  disabled?: boolean;
  checkedUserId?: string;
  selectedUserId?: string;
  handleUserClick?: (userId: string) => () => void;
}

export const UserList: React.FC<UserListProps> = ({
  users,
  disabled,
  checkedUserId,
  selectedUserId,
  handleUserClick
}) => {
  return (
    <ul
      className={css`
        pointer-events: ${disabled ? 'none' : 'auto'};
      `}
    >
      {users.map(user => (
        <UserListItem
          key={`user-${user.id}`}
          {...{
            user,
            isSelected: selectedUserId === user.id,
            isChecked: checkedUserId === user.id,
            onUserClick: handleUserClick
          }}
        />
      ))}
    </ul>
  );
};
